import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const base = `${API_BASE_URL}/api/admin/transport-master`;
const config = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}` },
});

export const listTransportMaster = async (type) => (await axios.get(`${base}/${type}`, config())).data;
export const saveTransportMaster = async (type, value) => {
  const url = value.id ? `${base}/${type}/${value.id}` : `${base}/${type}`;
  return (value.id ? await axios.put(url, value, config()) : await axios.post(url, value, config())).data;
};
export const deleteTransportMaster = async (type, id) => axios.delete(`${base}/${type}/${id}`, config());

export const fetchTransportMasterTrips = async (type, id) => (await axios.get(`${base}/${type}/${id}/trips`, config())).data;

export const fetchTransportOwnerPortal = async (accessKey) =>
  (await axios.get(`${API_BASE_URL}/api/transport-owner/portal/${accessKey}`)).data;

// One of the owner's live trips for the tracking map.
export const fetchOwnerTripTracking = async (accessKey, bookingId) =>
  (await axios.get(`${API_BASE_URL}/api/transport-owner/portal/${encodeURIComponent(accessKey)}/bookings/${bookingId}/tracking`)).data;

export const uploadTransportDocument = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(
    `${base}/documents/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data.publicUrl;
};

// How a trip's driver and vehicle performed. Recorded by the ops team from the booking screen once
// the trip is under way or finished.
export const fetchBookingTransportRating = async (bookingId) =>
  (await axios.get(`${API_BASE_URL}/api/admin/bookings/${bookingId}/transport-rating`, config())).data;

export const saveBookingTransportRating = async (bookingId, payload) =>
  (await axios.put(`${API_BASE_URL}/api/admin/bookings/${bookingId}/transport-rating`, payload, config())).data;

export const clearBookingTransportRating = async (bookingId) =>
  (await axios.delete(`${API_BASE_URL}/api/admin/bookings/${bookingId}/transport-rating`, config())).data;
